export const noWhitespaceValidator = (_, value) => {
  if (!value || value.trim() === "") {
    return Promise.reject(
      new Error("This field cannot be empty or spaces only")
    );
  }
  return Promise.resolve();
};

export const nonNegativeIntegerValidator = {
  pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
  message: "Must be a non-negative integer",
};

// Date validation functions
export const createExpirationDateValidator = (form) => (_, value) => {
  const startDate = form.getFieldValue("start");
  if (!value || !startDate) {
    return Promise.resolve();
  }

  if (value.isBefore(startDate, "day")) {
    return Promise.reject(
      new Error("Expiration date cannot be before start date")
    );
  }

  return Promise.resolve();
};

export const createDisabledExpirationDate = (form) => (current) => {
  const startDate = form.getFieldValue("start");
  if (!startDate) {
    return false;
  }
  return current && current.isBefore(startDate, "day");
};

export const getImageUrl = (imageUrl) => {
  if (!imageUrl) return "";
  if (imageUrl.startsWith("http")) return imageUrl;
  
  return `${process.env.REACT_APP_HETZNER_BASE_URL}${imageUrl}`;
};
